import Vue from 'vue';
import store from './../../store';
import unitOfMeasureTransformer from './../../transformers/unitOfMeasure';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const unitOfMeasures = unitOfMeasureTransformer.fetchCollection(data.data);

  store.dispatch('FetchAllUnitOfMeasures', unitOfMeasures);
  resolve(unitOfMeasures);
};

const failed = () => {
};

export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/unit_of_measures', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/unitOfMeasure/all.js